/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class ClearanceCode {
    clearanceCode_key: number;
    clearanceCodeStr: string;
    occurrence: string;
    wholesalerAllowed: string;
    description: string;
}
